import CollapseToggle from "./CollapseToggle";

const CollapseFooter = ({isCollapsed, setIsCollapsed, onCollapsedText, onNotCollapsedText, footerComponent, showToggle=true, customStyles}) => {
    if(!footerComponent && !showToggle){
        return <></>
    }

    return (
        <div className={`flex ${showToggle ? "justify-between" : ""} ${customStyles ? customStyles : ""}`}>
            {footerComponent && <div className={`${showToggle ? "" : "w-full"}`}>{footerComponent}</div>}

            {showToggle && (
                <CollapseToggle
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setIsCollapsed}
                        onCollapsedText={onCollapsedText}
                        onNotCollapsedText={onNotCollapsedText}
                        isUpIcon={!isCollapsed}
                        onClick={() => setIsCollapsed(!isCollapsed)}
                />
            )}
        </div>
    )
}

export default CollapseFooter